import { render, staticRenderFns } from "./RegisterTab.vue?vue&type=template&id=72b3eead&scoped=true"
import script from "./RegisterTab.vue?vue&type=script&lang=js"
export * from "./RegisterTab.vue?vue&type=script&lang=js"
import style0 from "./RegisterTab.vue?vue&type=style&index=0&id=72b3eead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b3eead",
  null
  
)

export default component.exports